var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditDataS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "69px",
    viewBox: "0 0 84 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit-data-S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-data-S",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,68.8853064 L33.33328,68.8853064 L33.33328,62.50615 L0,62.50615 L0,68.8853064 Z M32.0249488,39.5520201 L26.1332915,57.2186585 L43.8124299,51.3020013 L32.0249488,39.5520201 Z M64.4373969,7.13540525 L34.974944,36.5936914 L46.7582585,48.3853393 L76.2207114,18.9270531 L64.4373969,7.13540525 Z M76.2207114,1.21874805 C74.595714,-0.40624935 71.9540515,-0.40624935 70.3290541,1.21874805 L67.3832255,4.17707665 L79.16654,15.9687244 L82.1123686,13.0103959 C83.7415327,11.3853985 83.7415327,8.76040265 82.1123686,7.13540525 L76.2207114,1.21874805 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDataS);
export default __webpack_public_path__ + "static/media/edit-data-S.13e15e4c5918b4d3ff66913ba2a66300.svg";
export { ForwardRef as ReactComponent };